module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('graveyard-select'), _vm._v(" "), _c('custom-table', {
    attrs: {
      "edit": "/graves/{:id}",
      "add": "/graves/new",
      "search": "",
      "src-model": _vm.$store.getters.models('graves'),
      "cols": _vm.cols,
      "default-sort": _vm.defSort
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Grabverwaltung")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1438c3df!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/GraveOverview.vue
// module id = 427
// module chunks = 0